var _path, _path2, _path3, _circle, _rect, _circle2, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceBaringCalls(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    fill: "url(#n325t4ezea)",
    d: "M11.249 3.445h17.417v32.083H11.249z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fill: "#fff",
    d: "M26.367 3.461h2.75v32.083h-2.75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9 28.567 21.083.148M13.25 36h12.167a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4H13.249a4 4 0 0 0-4 4v25a4 4 0 0 0 4 4z",
    stroke: "url(#u064dxzthb)",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.487,
    cy: 32.398,
    r: 1.375,
    fill: "url(#19ff3k2j2c)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.473,
    y: 5.68,
    width: 4.583,
    height: 1.375,
    rx: 0.688,
    fill: "url(#dxo3940dvd)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.488,
    cy: 18.203,
    r: 6.25,
    stroke: "url(#mlwk9ktcee)",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15.045 22.77 8.887-8.887",
    stroke: "url(#y9l509gdwf)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "n325t4ezea",
    x1: 11.942,
    y1: 26.185,
    x2: 28.72,
    y2: 21.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u064dxzthb",
    x1: 9.839,
    y1: 26.39,
    x2: 29.636,
    y2: 20.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "19ff3k2j2c",
    x1: 18.222,
    y1: 32.973,
    x2: 20.503,
    y2: 31.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dxo3940dvd",
    x1: 17.655,
    y1: 6.654,
    x2: 18.927,
    y2: 4.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mlwk9ktcee",
    x1: 12.488,
    y1: 19.344,
    x2: 26.38,
    y2: 14.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y9l509gdwf",
    x1: 15.045,
    y1: 19.051,
    x2: 23.863,
    y2: 16.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceBaringCalls);
export default __webpack_public_path__ + "static/media/serviceBaringCalls.660f2231fab161189b3fb43b1c48ba42.svg";
export { ForwardRef as ReactComponent };